import MediaPlanConfig from './MediaPlanConfig';

export default MediaPlanConfig;
